export const CATEGORY_PALETTE = {
  blue: "var(--blue-9)",
  purple: "var(--purple-9)",
  orange: "var(--orange-9)",
  cyan: "var(--cyan-9)",
  plum: "var(--plum-9)",
  amber: "var(--amber-9)",
  red: "var(--red-9)",
  teal: "var(--teal-9)",
  sand: "var(--sand-9)",
} as const;

export const CATEGORY_COLORS = Object.values(CATEGORY_PALETTE);

export const SEQUENTIAL_COLORS = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
] as const;

/**
 * Hues for a chart's series, assigned in this order and never cycled: a
 * seventh series folds into "Other". Validated for colour-blind separation
 * and contrast in light and dark (see `--chart-series-*` in colors.css).
 */
export const SERIES_COLORS = [
  "var(--chart-series-1)",
  "var(--chart-series-2)",
  "var(--chart-series-3)",
  "var(--chart-series-4)",
  "var(--chart-series-5)",
  "var(--chart-series-6)",
] as const;
